/**
 * Featured medicines for the homepage.
 * These are manually curated "top sellers" that show the brand → generic connection.
 * Order matters: first items appear first on the page.
 * 
 * To update: add/remove/reorder entries. Each needs:
 * - brandName: The US brand name people know
 * - genericName: The active ingredient / chemical name
 * - description: One plain-language sentence about what it does
 * - category: Grouping label for the medicine
 * - ingredientUri: URI slug for linking to the ingredient detail page
 */
const featuredMedicines = [
  {
    brandName: "Cialis",
    genericName: "Tadalafil",
    description: "Used to treat erectile dysfunction and enlarged prostate symptoms.",
    category: "Men's Health",
    ingredientUri: "tadalafil",
  },
  {
    brandName: "Viagra",
    genericName: "Sildenafil",
    description: "Used to treat erectile dysfunction by improving blood flow.",
    category: "Men's Health",
    ingredientUri: "sildenafil",
  },
  {
    brandName: "Lipitor",
    genericName: "Atorvastatin",
    description: "Lowers cholesterol to reduce heart attack and stroke risk.",
    category: "Heart Health",
    ingredientUri: "atorvastatin",
  },
  {
    brandName: "Glucophage",
    genericName: "Metformin",
    description: "Controls blood sugar levels for people with type 2 diabetes.",
    category: "Diabetes",
    ingredientUri: "metformin",
  },
  {
    brandName: "Zoloft",
    genericName: "Sertraline",
    description: "Treats depression, anxiety, and panic disorders.",
    category: "Mental Health",
    ingredientUri: "sertraline",
  },
  {
    brandName: "Synthroid",
    genericName: "Levothyroxine",
    description: "Replaces thyroid hormone when your body doesn't make enough.",
    category: "Thyroid",
    ingredientUri: "levothyroxine",
  },
  {
    brandName: "Cozaar",
    genericName: "Losartan",
    description: "Lowers blood pressure and protects kidneys from diabetes damage.",
    category: "Blood Pressure",
    ingredientUri: "losartan",
  },
  {
    brandName: "Neurontin",
    genericName: "Gabapentin",
    description: "Treats nerve pain and helps control seizures.",
    category: "Pain & Nerve",
    ingredientUri: "gabapentin",
  },
];

export default featuredMedicines;
